import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import cx from 'classnames';
import {
    counter_VARIANTS,
    ESHOP_URL,
    FROM_WIDGET,
    SHOPPING_WITH_MK,
} from 'mk/autogenerated/translations/EshopProductWidget.929bef723a28295bdcf2a922d101cb63'
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { common_api_redirect_to_eshop_url } from 'mk/urls/functions';
import { EshopProductEntity } from 'mk2/apps/blogs/schemas';
import styles from 'mk2/apps/groups/containers/EshopProducts/EshopProduct.mscss';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Clamp } from 'mk2/components/Clamp';
import { Img } from 'mk2/components/Img';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import React from 'react';

export enum EshopProductWidgetSlot {
    GROUP_FEED_HEADER = 'group_feed_header',
    GROUP_FEED_POSTS = 'group_feed_posts',
    GROUP_FEED_FOOTER = 'group_feed_footer',

    FORUM_THREAD_HEADER = 'forum_thread_header',
    FORUM_THREAD_POSTS = 'forum_thread_posts',
    FORUM_THREAD_FOOTER = 'forum_thread_footer',

    COUNSELLING_FOOTER = 'counselling_footer',

    WIKI_ARTICLE = 'wiki_article',
    BAZAAR_GRID = 'bazaar_grid',
}

interface OwnProps {
    eshopProducts: EshopProductEntity[];
    slot: EshopProductWidgetSlot;
    pageId: number;
    widgetPosition: number;
    small: boolean;
    header: boolean;
}

type Props = OwnProps;

export default class EshopProductWidget extends React.PureComponent<Props> {

    public render() {
        const { eshopProducts, slot, pageId, widgetPosition, small, header } = this.props;

        if (!eshopProducts) {
            return null;
        }

        const avatarSize = small ? 24 : 36;
        const style = small ? 'small' : 'big';
        const headerText = small ? ESHOP_URL : SHOPPING_WITH_MK;

        const ESHOP_URL_ADRESS = {
            201: 'https://shop.modrykonik.com/sk-eur/sk/',
            202: 'https://shop.modrykonik.com/sk-eur/sk/', // /cz-czk/cz/ - asi toto ale neexistuje cz verzia
        }[ACTIVE_SERVER_ID];

        return (
            <div
                className={cx(
                            styles.EshopProductWidget,
                            styles[`EshopProductWidget__${style}`],
                )}>
                {header &&
                    <>
                        <div
                            className={styles[`EshopProductWidget__container${style}`]}
                        >
                            <Img
                                className={styles.EshopProductWidget__containerImg}
                                src={assetUrl + 'img/avatars/user/no_photo_50_1.png'}
                                width={avatarSize}
                                height={avatarSize}
                            />
                            <Link to={ESHOP_URL_ADRESS}>
                                <span className={styles.EshopProductWidget__containerspan}>
                                    <div className={cx(
                                            styles.EshopProductWidget__containerdiv,
                                            styles.EshopProductWidget__profileName,
                                         )}
                                    >
                                        {headerText}

                                    </div>
                                    {!small &&
                                        <div className={cx(
                                                styles.EshopProductWidget__containerdiv,
                                                styles.EshopProductWidget__eshop,
                                             )}
                                        >
                                            {ESHOP_URL}
                                        </div>
                                    }
                                </span>
                            </Link>
                        </div>
                        {small &&
                            <div className={styles.EshopProductWidget__line}/>
                        }
                    </>
                }
                <div className={styles[`EshopProductWidget__products${style}`]}>
                    {eshopProducts.map((eshopProduct, index) => {
                        return (
                            <React.Fragment key={index}>
                                <EshopProduct
                                    eshopProduct={eshopProduct}
                                    eshopProductPosition={index}
                                    widgetPosition={widgetPosition}
                                    slot={slot}
                                    pageId={pageId}
                                    key={index}
                                    small={small}
                                    style={style}
                                />
                                {(small && index === 0) &&
                                    <div className={styles.EshopProductWidget__line}/>
                                }
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        );
    }
}

interface EshopProductProps {
    eshopProduct: EshopProductEntity;
    eshopProductPosition: number;
    widgetPosition: number;
    slot: EshopProductWidgetSlot;
    pageId: number;
    small: boolean;
    style: string;
}

function getFullPrice(oldPrice: number) {
    const helpArray = oldPrice.toString().split('.');
    if (helpArray.length > 1) {
        const cents = helpArray[1].split('');
        if (cents.length === 1 && cents[0] !== '0') {
            return helpArray[0] + '.' + cents[0] + '0';
        }
    }
    return oldPrice.toString();
}

function fullPriceVariants(eshopProduct) {
    let cheapest = eshopProduct.variants[0].x_price_gross_amount;
    if (cheapest) {
        for (let i = 0; i < eshopProduct.variants.length; i++) {
            const variant = eshopProduct.variants[i].x_price_gross_amount;
            cheapest = variant < cheapest ? variant : cheapest;
        }
        return cheapest;
    } else return 0;
}

const EshopProduct: React.FunctionComponent<EshopProductProps> = ({
    eshopProduct,
    eshopProductPosition,
    pageId,
    slot,
    widgetPosition,
    small,
    style,
}) => {

    let currency = '';
    let price = null;
    let fullPrice = '';
    let hasVariants = false;

    if (eshopProduct.variants.length > 1) {
        currency = eshopProduct.variants[0].x_price_gross_currency !== null
            ? eshopProduct.variants[0].x_price_gross_currency
            : '';
        fullPrice = FROM_WIDGET + ' ' + fullPriceVariants(eshopProduct);
        hasVariants = true;
    } else {
        currency = eshopProduct.x_price_gross_currency !== null
            ? eshopProduct.x_price_gross_currency
            : 'XX';
        price = eshopProduct.x_price_gross_amount;
        if (price !== null) {
            fullPrice = getFullPrice(price);    // change price from 19,6 to 19,60
        }
    }

    if (currency === 'EUR') {
        currency = '€';
    } else if (currency === 'CZK') {
        currency = 'Kč';
    }

    const imageUrl = eshopProduct.thumbnail?.url !== null
        ? eshopProduct.thumbnail?.url
        : '';

    const imageAlt = eshopProduct.thumbnail?.alt !== null
        ? eshopProduct.thumbnail?.alt
        : '';

    const eshopProductName = eshopProduct.name !== null
        ? eshopProduct.name
        : '';

    const priceAndCurrency = `${fullPrice}${currency}`;

    const smallHeaderName = eshopProductName.length <= 67
                        ? `${eshopProductName} • `
                        : eshopProductName.slice(0, 67) + '... • ';

    const priceCurrencyDiv = () => {
        return (
            <div className={styles[`EshopProduct__priceColor${style}`]}>
                {priceAndCurrency}
            </div>
        );
    };

    const hasVariantsValue = hasVariants ? 'Variants' : 'No';

    const button = (
        <div className={styles.EshopProduct__button}>
            <object>
                <Btn
                    type={BtnType.BlueOutline}
                    icon={faArrowRight}
                    link={common_api_redirect_to_eshop_url(eshopProduct.slug, {
                        epid: eshopProduct.idOriginal,
                        epos: eshopProductPosition,
                        wpos: widgetPosition,
                        slot,
                        pid: pageId,
                    })}
                />
            </object>
        </div>
    );

    return (
        <div className={styles[`EshopProduct__box${style}`]}>
            <Link to={
                common_api_redirect_to_eshop_url(
                    eshopProduct.slug, {
                        epid: eshopProduct.idOriginal,
                        epos: eshopProductPosition,
                        wpos: widgetPosition,
                        slot,
                        pid: pageId,
                    })}>
                <div className={styles[`EshopProduct__container${style}`]}>
                    <div className={styles[`EshopProduct__containerImg${style}`]}>
                        <Img
                             width={undefined}
                             height={undefined}
                             src={imageUrl}
                             alt={imageAlt}
                             className={styles[`EshopProduct__containerImgDetail${style}`]}
                         />
                    </div>
                    <div className={styles[`EshopProduct__body${style}`]}>
                        {small &&
                            <>
                                {smallHeaderName}
                                {priceCurrencyDiv()}
                            </>
                        }
                        {!small &&
                            <>
                                <Clamp clamp={2}>
                                    <div>{eshopProductName}</div>
                                </Clamp>
                                <div className={styles.EshopProduct__buttonPrice}>
                                    <div className={styles[`EshopProduct__price${hasVariantsValue}`]}>
                                        {priceCurrencyDiv()}
                                        {hasVariants &&
                                            <div className={styles.EshopProduct__variants}>
                                                <Interpolate
                                                    i18nKey={counter_VARIANTS}
                                                    counter={eshopProduct.variants.length}
                                                />
                                            </div>
                                        }
                                    </div>
                                    {button}
                                </div>
                            </>
                        }

                    </div>
                    {small &&
                        <>
                            {button}
                        </>
                    }
                </div>
            </Link>
        </div>
    );
};
